
    module.exports = function cssToMuiLoader(theme) {
      
      return {
        
        'priceSummary': {'padding': `0.5rem 0rem`,},'totalPriceText': {'fontFamily': `'Lato-Regular', sans-serif`,'fontWeight': `bold`,'color': `#ffffff`,},'priceItem': {'display': `flex`,'justifyContent': `space-between`,'padding': `0.5rem 0rem`,'color': `#ffffff`,},
        
      };
    };
  